import { gozokiApiWithAuth } from '../gozokiApi'
import type { DocumentItem } from '../queries/storeProjects.queries'

// Upload photo for a store project
export const uploadStoreProjectPhoto = async ({ id, photo }: { id: string; photo: File }) => {
  const formData = new FormData()
  formData.append('photo', photo)

  const response = await gozokiApiWithAuth.post<{ url: string; photoUrls: string[] }>(
    `/store-projects/${id}/upload-photo`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
  return response.data
}
// Upload document for a store project
export const uploadStoreProjectDocument = async ({
  id,
  document,
}: {
  id: string
  document: File
}) => {
  const formData = new FormData()
  formData.append('document', document)

  const response = await gozokiApiWithAuth.post<{
    document: DocumentItem
    documents: DocumentItem[]
  }>(`/store-projects/${id}/upload-document`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}
